import {
  LastDateTimeRange,
  TimePeriodUnit,
} from '@modules/common/components/DateRangePicker/types';
import { TimeUnit } from 'generated/graphql';

export function getAggregatePeriodFromLastDateRange(
  dateRange: LastDateTimeRange,
) {
  if (!dateRange.value) {
    return;
  }

  switch (dateRange.unit) {
    case TimePeriodUnit.Day:
      return dateRange.value < 30
        ? TimeUnit.Day
        : dateRange.value < 90
        ? TimeUnit.Week
        : TimeUnit.Month;

    case TimePeriodUnit.Week:
      return dateRange.value < 4
        ? TimeUnit.Day
        : dateRange.value < 12
        ? TimeUnit.Week
        : TimeUnit.Month;

    case TimePeriodUnit.Month:
      return dateRange.value < 1
        ? TimeUnit.Day
        : dateRange.value < 3
        ? TimeUnit.Week
        : TimeUnit.Month;
  }
}
